import { useCallback } from 'react';

import { useToast } from 'components/hooks/useToast';

import { TOAST_STATUSES } from 'constants/ProjectConstants';

export const useCopyToClipboard = ({ text, successfulMessage, failureMessage }) => {
  const toast = useToast();

  const copyToClipboard = useCallback(() => {
    navigator.clipboard
      .writeText(text)
      .then(() => {
        toast({
          title: successfulMessage,
          status: TOAST_STATUSES.SUCCESS,
        });
      })
      .catch(() => {
        toast({
          title: failureMessage,
          status: TOAST_STATUSES.ERROR,
        });
      });
  }, [text, toast, successfulMessage, failureMessage]);

  return copyToClipboard;
};
